import React, {useMemo, useCallback} from 'react'
import {reorder} from '../../../editorActions'
import {NodesList} from './NodesList'

const SidebarPanel = ({state, dispatch, onOpenRemoveBg}) => {
    const selection = state?.selection || {nodeIds: []}

    const nodes = useMemo(() => {
        if (!state) return []
        const order = state.order || []
        const map = state.nodes
        if (!map) return []
        return order.map((id) => map.get(id)).filter(Boolean)
    }, [state])

    const selectedNodeIds = selection?.nodeIds || []
    const selectedNode = selectedNodeIds.length === 1 ? nodes.find((n) => n.id === selectedNodeIds[0]) : null

    const onReorder = useCallback(
        (nodeId, toIndex) => {
            dispatch(reorder(nodeId, toIndex))
        },
        [dispatch],
    )

    return (
        <section className="SidebarPanel" aria-label="Layers">
            <header className="SidebarPanel__Header">
                <h2 className="SidebarPanel__Title">Layers</h2>
            </header>
            <div className="SidebarPanel__Content">
                <NodesList
                    nodes={nodes}
                    selection={selection}
                    selectedNode={selectedNode}
                    dispatch={dispatch}
                    onReorder={onReorder}
                    onRemoveBackground={onOpenRemoveBg}
                />
            </div>
        </section>
    )
}

export default SidebarPanel
